import axios from 'axios';

const unsplashURL = 'https://api.unsplash.com/search/photos/';
const pixabayURL = 'https://pixabay.com/api/';
const giphyURL = 'https://api.giphy.com/v1/gifs/search';
const unsplashKey = process.env.UNSPLASH_KEY;
const pixabayKey = process.env.PIXABAY_KEY;
const giphyKey = process.env.GIPHY_KEY;

const paginateGrid = (results, gridSize) => {
  return results
    .reduce(([page = [], ...rest], result) => {
      if (page.length < gridSize) {
        return [[...page, result], ...rest];
      }

      return [[result], page, ...rest];
    }, [])
    .reverse();
};

export const search = async (query, providers, gridSize) => {
  const providersRequests = {
    unsplash: () =>
      axios.get(unsplashURL, {
        params: {
          client_id: unsplashKey,
          query,
          per_page: 24,
          content_filter: 'high',
        },
      }),
    pixabay: () =>
      axios.get(pixabayURL, {
        params: {
          key: pixabayKey,
          q: query,
          safesearch: true,
          per_page: 24,
          image_type: 'photo',
        },
      }),
    giphy: () =>
      axios.get(giphyURL, {
        params: {
          api_key: giphyKey,
          q: query,
          limit: 100,
          rating: 'g',
        },
      }),
  };

  const selectedRequests = providers.reduce((prev, provider) => {
    return providersRequests[provider]
      ? [...prev, providersRequests[provider]()]
      : prev;
  }, []);

  const responses = await Promise.all(selectedRequests);

  return responses.reduce((prev, curr) => {
    switch (curr.config.url) {
      case unsplashURL:
        return { ...prev, unsplash: paginateGrid(curr.data.results, gridSize) };
      case pixabayURL:
        return { ...prev, pixabay: paginateGrid(curr.data.hits, gridSize) };
      case giphyURL:
        return { ...prev, giphy: paginateGrid(curr.data.data, gridSize) };
      default:
        return prev;
    }
  }, {});
};
